import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'

import {
   Button,
   Hierarchy,
   PopoverWithTriggerWithRef,
   SubVariant
} from '@flowwai-frontend/design-system'

import { MARK_LOCATION_FEATURE_TOOLTIP } from '../../../constants'
import { imageUrls } from '../../../constants/imageConstants'
import { useMapsUtilityContext } from '../../../hooks/useMapsUtilityContext'
import * as Styles from './styles'

interface Props {
   triggerRef: React.RefObject<HTMLElement>
}

const MarkLocationToolHelpPopup = (props: Props): React.ReactElement => {
   const { triggerRef } = props

   const [isOpen, setIsOpen] = useState(false)

   const { mapsT } = useMapsUtilityContext()

   const onClickConfirm = (): void => {
      setIsOpen(false)
      localStorage.setItem(MARK_LOCATION_FEATURE_TOOLTIP, 'true')
   }

   const renderPopoverBody = (): React.ReactElement => (
      <div className={Styles.markLocationPopup}>
         <img
            className={Styles.markLocationPopupImage}
            src={imageUrls.markLocationPopupImage}
         />

         <div className={Styles.markLocationPopupHelpText}>
            {mapsT('featureTooltips.markLocation')}
         </div>

         <Button
            size={'Small'}
            hierarchy={Hierarchy.Primary}
            subVariant={SubVariant.Primary}
            onClick={onClickConfirm}
         >
            {mapsT('featureTooltips.okGotIt')}
         </Button>

         <div className={Styles.markLocationPopupAnchor} />
      </div>
   )

   const openPopupWithTimeout = (): void => {
      setTimeout(() => {
         setIsOpen(
            !(localStorage.getItem(MARK_LOCATION_FEATURE_TOOLTIP) === 'true')
         )
      }, 1000)
   }

   useEffect(openPopupWithTimeout, [])

   return (
      <PopoverWithTriggerWithRef
         isOpen={isOpen}
         offset={20}
         onOpenChange={setIsOpen}
         placement='top'
         popoverBody={renderPopoverBody}
         popoverStyle={{ overflow: 'unset' }}
         shouldDisablePageActions
         triggerRef={triggerRef}
      />
   )
}

export default observer(MarkLocationToolHelpPopup)
